import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import ProjectSelect from "@/components/ProjectSelect";
import FirmSelect from "@/components/FirmSelect";
import PeriodSelect from "@/components/PeriodSelect";
import DateInput from "@/components/DateInput";

export const EMPTY_FILTERS = { project_id: "", firm_id: "", worker: "", role: "", status: "", work_item: "", block: "", date_from: "", date_to: "", q: "" };

function F({ label, children }) {
  return <div><div className="text-xs font-semibold text-muted-foreground mb-1">{label}</div>{children}</div>;
}

function OptSelect({ value, onChange, options, all, testid }) {
  return (
    <Select value={value || "__all__"} onValueChange={v => onChange(v === "__all__" ? "" : v)}>
      <SelectTrigger className="w-36" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__all__">{all}</SelectItem>
        {Object.entries(options || {}).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export default function TimesheetFilters({ f, setF, projects, firms, opts, years, periodKey, onReset }) {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <div className="rounded-xl border border-border bg-card p-4 mb-5 flex flex-wrap items-end gap-3" data-testid="ts-filter-bar">
      <F label="Şantiye"><ProjectSelect projects={projects} value={f.project_id} onChange={set("project_id")} testid="ts-filter-project" /></F>
      <F label="Firma"><FirmSelect firms={firms} value={f.firm_id} onChange={set("firm_id")} testid="ts-filter-firm" /></F>
      <F label="Çalışan"><Input className="w-40" list="ts-workers" value={f.worker} onChange={e => set("worker")(e.target.value)} placeholder="Ad ara" data-testid="ts-filter-worker" /></F>
      <F label="Görev"><OptSelect value={f.role} onChange={set("role")} options={opts.roles} all="Tüm görevler" testid="ts-filter-role" /></F>
      <F label="Durum"><OptSelect value={f.status} onChange={set("status")} options={opts.statuses} all="Tüm durumlar" testid="ts-filter-status" /></F>
      <F label="İş Kalemi"><Input className="w-40" list="ts-items" value={f.work_item} onChange={e => set("work_item")(e.target.value)} data-testid="ts-filter-item" /></F>
      <F label="Blok / Mahal"><Input className="w-32" list="ts-blocks" value={f.block} onChange={e => set("block")(e.target.value)} data-testid="ts-filter-block" /></F>
      <F label="Dönem"><PeriodSelect key={periodKey} years={years} onRange={(a, b) => setF({ ...f, date_from: a, date_to: b })} testid="ts-filter-period" /></F>
      <F label="Başlangıç"><DateInput className="w-36" value={f.date_from} onChange={e => setF({ ...f, date_from: e.target.value })} data-testid="ts-filter-from" /></F>
      <F label="Bitiş"><DateInput className="w-36" value={f.date_to} onChange={e => setF({ ...f, date_to: e.target.value })} data-testid="ts-filter-to" /></F>
      <F label="Not / serbest arama"><Input className="w-40" value={f.q} onChange={e => set("q")(e.target.value)} data-testid="ts-filter-q" /></F>
      <Button variant="ghost" size="sm" onClick={onReset} data-testid="ts-filter-reset">Temizle</Button>
      <datalist id="ts-workers">{(opts.workers || []).map(w => <option key={w} value={w} />)}</datalist>
      <datalist id="ts-items">{(opts.work_items || []).map(w => <option key={w} value={w} />)}</datalist>
      <datalist id="ts-blocks">{(opts.blocks || []).map(w => <option key={w} value={w} />)}</datalist>
    </div>
  );
}
